import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import ProfileTab from "../../../core/common/profiletab";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";

const PersonalInfo = () => {
  const routes = all_routes;
  const {
    data: onboardingstatus,
    loading: onboardingstatusLoading,
    error: onboardingstatusError,
  } = useApi("/api/onboarding/final-status", {
    method: "GET",
    autoCall: true,
  });

  const validateSpouseDetails = () => {
    const marriedStatuses = ["Married", "Divorced", "Widowed", "Separated"];

    if (marriedStatuses.includes(data.marital_status)) {
      if (!data.spouse_name || !data.spouse_blood_group || !data.spouse_location) {
        Swal.fire({
          icon: "error",
          title: "Incomplete Spouse Details",
          text: "Please fill Name, Blood Group, and Location of spouse.",
          confirmButtonColor: "#d33",
        });
        return false; // invalid
      }
    }
    return true; // valid
  };


  const status = onboardingstatus?.data?.onb_status;
  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };
  const [isEditable, setIsEditable] = useState(false);
  const [data, setData] = useState({
    ID: "",
    legal_name: "",
    nick_name: "",
    date_of_birth: "",
    gender: "",
    blood_group: "",
    marital_status: "",
    citizenship: "",
    emergency_name: "",
    emergency_phone: "",
    emergency_address: "",
    relation: "",
    spouse_name: "",
    spouse_dob: "",
    spouse_blood_group: "",
    spouse_occupation: "",
    spouse_company: "",
    spouse_location: "",
  });

  const getInputData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const {
    data: personalViewData,
    loading: personalViewLoading,
    error: personalViewError,
  } = useApi("/api/onboarding/view-personal-details", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (personalViewData?.data) {
      setData((prev) => ({
        ...prev,
        ...personalViewData.data,
        date_of_birth: dayjs(personalViewData.data.date_of_birth, "DD-MM-YYYY"),
        spouse_dob: dayjs(personalViewData.data.spouse_dob, "DD-MM-YYYY"),
      }));
    }
  }, [personalViewData]);

  const {
    data: personalData,
    loading,
    error,
    callApi: postPersonalData,
  } = useApi("/api/onboarding/add-personal-details", {
    method: "POST",
    autoCall: false,
  });

  const postData = async (e: any) => {
    e.preventDefault();
    if (!validateSpouseDetails()) return;
    const payload = {
      legal_name: data.legal_name,
      nick_name: data.nick_name,
      date_of_birth: dayjs(data.date_of_birth).format("DD-MM-YYYY"),
      gender: data.gender.toUpperCase(),
      blood_group: data.blood_group,
      marital_status: data.marital_status,
      citizenship: data.citizenship,
      emergency_name: data.emergency_name,
      emergency_address: data.emergency_address,
      emergency_phone: data.emergency_phone,
      relation: data.relation,
      spouse_name: data.spouse_name,
      spouse_dob: data.spouse_dob
        ? dayjs(data.spouse_dob).format("DD-MM-YYYY")
        : "",
      spouse_blood_group: data.spouse_blood_group,
      spouse_occupation: data.spouse_occupation,
      spouse_company: data.spouse_company,
      spouse_location: data.spouse_location,
    };
    try {
      const response = await postPersonalData(payload);
      console.log("API Success:", response);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        });
      }
    } catch (err: any) {
      console.error("API Error in component:", err);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          err?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const {
    data: personalEditData,
    loading: personalEditLoading,
    error: personalEditError,
    callApi: editPersonalData,
  } = useApi("/api/onboarding/edit-personal-details", {
    method: "POST",
    autoCall: false,
  });

  const handleEdit = async (e: any) => {
    e.preventDefault();
    if (!validateSpouseDetails()) return;
    try {
      const payload = {
        details_id: data.ID || "",
        legal_name: data.legal_name,
        nick_name: data.nick_name,
        date_of_birth: dayjs(data.date_of_birth).format("DD-MM-YYYY"),
        gender: data.gender.toUpperCase(),
        blood_group: data.blood_group,
        marital_status: data.marital_status,
        citizenship: data.citizenship,
        emergency_name: data.emergency_name,
        emergency_address: data.emergency_address,
        emergency_phone: data.emergency_phone,
        relation: data.relation,
        spouse_name: data.spouse_name,
        spouse_dob: dayjs(data.spouse_dob).format("DD-MM-YYYY"),
        spouse_blood_group: data.spouse_blood_group,
        spouse_occupation: data.spouse_occupation,
        spouse_company: data.spouse_company,
        spouse_location: data.spouse_location,
      };
      const response = await editPersonalData(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        });
        setIsEditable(false);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Personal</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Administration</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Personal
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
            <div className="row">
              <div className="col-xl-3 theiaStickySidebar">
                <div
                  className="stickybar"
                  style={{ position: "sticky", top: "50px" }}
                >
                  <ProfileTab />
                </div>
              </div>
              <div className="col-xl-9">
                <div className="card">
                  <div className="card-body">
                    <div className="border-bottom mb-3 pb-3">
                      <h4>Personal</h4>
                    </div>
                    <form>
                      {/* Present Address Section */}
                      <div className="border-bottom mb-3">
                        <div className="row">
                          <div className="col-md-12">
                            <h6 className="mb-3">Your personal details</h6>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Legal Name<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter your legal name"
                                  name="legal_name"
                                  onChange={getInputData}
                                  readOnly={data.ID ? !isEditable : false}
                                  value={data.legal_name}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Nick Name
                                  {/* <sup className="text-danger">*</sup> */}
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter your nickname"
                                  name="nick_name"
                                  onChange={getInputData}
                                  readOnly={data.ID ? !isEditable : false}
                                  value={data.nick_name}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Date of Birth
                                  <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <div className="input-icon-end position-relative">
                                  <DatePicker
                                    className="form-control datetimepicker"
                                    format="DD-MM-YYYY"
                                    getPopupContainer={getModalContainer}
                                    placeholder="DD-MM-YYYY"
                                    name="date_of_birth"
                                    value={
                                      data.date_of_birth
                                        ? dayjs(
                                          data.date_of_birth,
                                          "YYYY-MM-DD"
                                        )
                                        : null
                                    }
                                    onChange={(date) =>
                                      setData((prev) => ({
                                        ...prev,
                                        date_of_birth: date
                                          ? date.format("YYYY-MM-DD")
                                          : "",
                                      }))
                                    }
                                    disabledDate={(current) =>
                                      current &&
                                      current.isAfter(dayjs().startOf("day"))
                                    }
                                    disabled={data.ID ? !isEditable : false}
                                    required
                                  />
                                  <span className="input-icon-addon">
                                    <i className="ti ti-calendar text-gray-7" />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Gender<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <select
                                  className="form-select"
                                  name="gender"
                                  onChange={getInputData}
                                  disabled={data.ID ? !isEditable : false}
                                  value={data.gender}
                                  required
                                >
                                  <option value="">Select gender</option>
                                  <option value="MALE">Male</option>
                                  <option value="FEMALE">Female</option>
                                  <option value="OTHER">Other</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Blood Group
                                  <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <select
                                  className="form-select"
                                  name="blood_group"
                                  onChange={getInputData}
                                  disabled={data.ID ? !isEditable : false}
                                  value={data.blood_group}
                                  required
                                >
                                  <option value="">Select blood group</option>
                                  <option value="A+">A+</option>
                                  <option value="A-">A-</option>
                                  <option value="B+">B+</option>
                                  <option value="B-">B-</option>
                                  <option value="AB+">AB+</option>
                                  <option value="AB-">AB-</option>
                                  <option value="O+">O+</option>
                                  <option value="O-">O-</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Marital Status<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <select
                                  className="form-select"
                                  name="marital_status"
                                  onChange={getInputData}
                                  disabled={data.ID ? !isEditable : false}
                                  value={data.marital_status}
                                  required
                                >
                                  <option value="" selected disabled>
                                    Select marital status
                                  </option>
                                  <option value="Single">Single</option>
                                  <option value="Married">Married</option>
                                  <option value="Divorced">Divorced</option>
                                  <option value="Widowed">Widowed</option>
                                  <option value="Separated">Separated</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Citizenship<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter your citizenship"
                                  name="citizenship"
                                  onChange={getInputData}
                                  readOnly={data.ID ? !isEditable : false}
                                  value={data.citizenship}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Emergency Contact Section */}
                      <div className="border-bottom mb-3">
                        <div className="row">
                          <div className="col-md-12">
                            <h6 className="mb-3">Emergency Contact</h6>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Name
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter contact name"
                                  name="emergency_name"
                                  onChange={getInputData}
                                  readOnly={data.ID ? !isEditable : false}
                                  value={data.emergency_name}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Phone
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="tel"
                                  className="form-control"
                                  placeholder="Enter contact phone number"
                                  name="emergency_phone"
                                  onChange={getInputData}
                                  readOnly={data.ID ? !isEditable : false}
                                  maxLength={10}
                                  pattern="\d*"
                                  inputMode="numeric"
                                  onKeyPress={(e) => {
                                    if (!/^\d$/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={data.emergency_phone}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="row align-items-start mb-3">
                              <div className="col-xxl-2 col-md-3">
                                <label className="form-label mb-md-0">
                                  Address
                                </label>
                              </div>
                              <div className="col-xxl-10 col-md-9">
                                <textarea
                                  className="form-control"
                                  rows={2}
                                  placeholder="Enter contact address"
                                  name="emergency_address"
                                  onChange={getInputData}
                                  readOnly={data.ID ? !isEditable : false}
                                  value={data.emergency_address}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Relation
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter your relation with contact"
                                  name="relation"
                                  onChange={getInputData}
                                  readOnly={data.ID ? !isEditable : false}
                                  value={data.relation}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Spouse Details Section */}
                      {
                        data.marital_status !== "Single" && data.marital_status !== "" ? <div className="border-bottom mb-3">
                          <div className="row">
                            <div className="col-md-12">
                              <h6 className="mb-3">Spouse Details</h6>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="row align-items-center mb-3">
                                <div className="col-md-4">
                                  <label className="form-label mb-md-0">
                                    Name
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter spouse's name"
                                    name="spouse_name"
                                    onChange={getInputData}
                                    readOnly={data.ID ? !isEditable : false}
                                    value={data.spouse_name}
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row align-items-center mb-3">
                                <div className="col-md-4">
                                  <label className="form-label mb-md-0">
                                    Date of Birth

                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <div className="input-icon-end position-relative">
                                    <DatePicker
                                      className="form-control datetimepicker"
                                      format="DD-MM-YYYY"
                                      getPopupContainer={getModalContainer}
                                      placeholder="DD-MM-YYYY"
                                      name="spouse_dob"
                                      value={
                                        data.spouse_dob && dayjs(data.spouse_dob, "YYYY-MM-DD").isValid()
                                          ? dayjs(data.spouse_dob, "YYYY-MM-DD")
                                          : null
                                      }
                                      onChange={(date) =>
                                        setData((prev: any) => ({
                                          ...prev,
                                          spouse_dob: date ? date.format("YYYY-MM-DD") : null,
                                        }))
                                      }
                                      disabledDate={(current) =>
                                        current && current.isAfter(dayjs().startOf("day"))
                                      }
                                      disabled={data.ID ? !isEditable : false}
                                    />

                                    <span className="input-icon-addon">
                                      <i className="ti ti-calendar text-gray-7" />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row align-items-center mb-3">
                                <div className="col-md-4">
                                  <label className="form-label mb-md-0">
                                    Blood Group

                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <select
                                    className="form-select"
                                    name="spouse_blood_group"
                                    onChange={getInputData}
                                    disabled={data.ID ? !isEditable : false}
                                    value={data.spouse_blood_group}
                                  >
                                    <option value="">Select blood group</option>
                                    <option value="A+">A+</option>
                                    <option value="A-">A-</option>
                                    <option value="B+">B+</option>
                                    <option value="B-">B-</option>
                                    <option value="AB+">AB+</option>
                                    <option value="AB-">AB-</option>
                                    <option value="O+">O+</option>
                                    <option value="O-">O-</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row align-items-center mb-3">
                                <div className="col-md-4">
                                  <label className="form-label mb-md-0">
                                    Occupation
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter spouse's occupation"
                                    name="spouse_occupation"
                                    onChange={getInputData}
                                    readOnly={data.ID ? !isEditable : false}
                                    value={data.spouse_occupation}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row align-items-center mb-3">
                                <div className="col-md-4">
                                  <label className="form-label mb-md-0">
                                    Company
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter spouse's company name"
                                    name="spouse_company"
                                    onChange={getInputData}
                                    readOnly={data.ID ? !isEditable : false}
                                    value={data.spouse_company}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row align-items-center mb-3">
                                <div className="col-md-4">
                                  <label className="form-label mb-md-0">
                                    Location
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter spouse's location"
                                    name="spouse_location"
                                    onChange={getInputData}
                                    readOnly={data.ID ? !isEditable : false}
                                    value={data.spouse_location}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> : ""
                      }


                      {/* Buttons */}
                      <div className="d-flex align-items-center justify-content-end">
                        {data.ID ? (
                          isEditable ? (
                            <>
                              <button
                                type="button"
                                className="btn btn-outline-light border w-25"
                                onClick={(e: any) => {
                                  e.preventDefault();
                                  setIsEditable(false);
                                }}
                              >
                                Cancel
                              </button>
                              &nbsp;
                              <button
                                type="submit"
                                className="btn btn-primary w-25"
                                onClick={handleEdit}
                              >
                                Update
                              </button>
                            </>
                          ) : (
                            (() => {
                              const canEdit =
                                status === "In Progress" ||
                                status === "Rejected" ||
                                status === "Re Open" ||
                                status === "Not Started";

                              return (
                                <button
                                  type="button"
                                  className="btn btn-primary w-25"
                                  onClick={(e: any) => {
                                    e.preventDefault();
                                    if (canEdit) setIsEditable(true);
                                  }}
                                  disabled={!canEdit}
                                  title={
                                    canEdit
                                      ? "Edit"
                                      : "Editing is disabled for this status"
                                  }
                                  style={{
                                    cursor: canEdit ? "pointer" : "not-allowed",
                                    opacity: canEdit ? 1 : 0.6,
                                  }}
                                >
                                  Edit
                                </button>
                              );
                            })()
                          )
                        ) : (
                          <button
                            type="submit"
                            className="btn btn-primary custom_button w-25"
                            onClick={postData}
                          >
                            Save
                          </button>
                        )}
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
            <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
    </div>
  );
};

export default PersonalInfo;
